(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-product-gallery-progress]').forEach((wrapper) => {
    const gallery = wrapper.closest('product-gallery');
    const carousel = gallery ? gallery.querySelector('[data-product-gallery-carousel]') : null;
    const progressBar = wrapper.querySelector('progress-bar');
    if (!carousel || !progressBar) return;

    const update = () => {
      const total = carousel.cells ? carousel.cells.length : carousel.children.length;
      const index = carousel.selectedIndex || 0;
      const visible = Math.max(1, Math.min(total, carousel.groupCells || 1));
      const progress = total > 0 ? Math.min(1, (index + visible) / total) : 0;
      progressBar.valueMax = 100;
      progressBar.valueNow = Math.round(progress * 100);
    };

    update();
    carousel.addEventListener('carousel:change', update);
  });
  } catch(e) { console.error(e); }
})();

})();
